/**
 * We were reusing the same code enough that it made sense to make this a pass-through
 *    component for reuse. Keep logic out of here; if you need to do anything fancy do it
 *    in your form component.
 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IconComponent } from '@degreed/apollo';
import { Trigger } from '../../model';

@Component({
  selector: 'dgx-trigger-back-cancel-save-buttons',
  imports: [IconComponent],
  templateUrl: './trigger-back-cancel-save-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TriggerBackCancelSaveButtonsComponent {
  @Input() public isSaving: boolean = false;
  @Input() public i18n: { [key: string]: string };

  @Output() public saveEmitter = new EventEmitter<Trigger>();

  @Output() public cancelEmitter = new EventEmitter<Trigger>();

  @Output() public backEmitter = new EventEmitter<Trigger>();

  public onCancel(): void {
    this.cancelEmitter.emit();
  }
  public onSave(): void {
    this.saveEmitter.emit();
  }
  public onBack(): void {
    this.backEmitter.emit();
  }
}
